/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var MembershipEnum;

(function (MembershipEnum) {
  MembershipEnum["ICEAW"] = "ICEAW";
  MembershipEnum["ICAS"] = "ICAS";
  MembershipEnum["ICAI"] = "ICAI";
  MembershipEnum["ACCA"] = "ACCA";
  MembershipEnum["AAT"] = "AAT";
  MembershipEnum["ATT"] = "ATT";
  MembershipEnum["AIA"] = "AIA";
  MembershipEnum["CIMA"] = "CIMA";
  MembershipEnum["CIOT"] = "CIOT";
  MembershipEnum["NONE"] = "none";
})(MembershipEnum || (MembershipEnum = {}));